const REVIEW_MODE = 3;
const messageMap = {
  someInReview: 'Some selected students are already in Review mode. Please unselect them and try again.',
  allInReview: 'All selected students are already in Review mode. No changes were made.',
  allCompleted: 'Students with a completed assignment cannot be set to Review.',
  someCompleted: 'Some selected students have completed the assignment. Please unselect them and try again.'
};

export const validateStudentsForReviewMode = (selectedResults = []) => {
  const alreadyInReview = selectedResults.filter((item) => item.assignmentOptions?.mode === REVIEW_MODE);

  if (alreadyInReview.length > 0 && selectedResults.length !== alreadyInReview.length) {
    return {
      isValid: false,
      message: messageMap.someInReview
    };
  }

  if (alreadyInReview.length > 0 && selectedResults.length === alreadyInReview.length) {
    return {
      isValid: false,
      message: messageMap.allInReview
    };
  }

  const completedStudents = selectedResults.filter((item) => item.dateCompleted);

  const messages = [];

  if (completedStudents.length > 0) {
    messages.push(
      selectedResults.length === completedStudents.length
        ? messageMap.allCompleted
        : messageMap.someCompleted
    );
  }

  if (messages.length > 0) {
    return {
      isValid: false,
      message: messages.join(' ')
    };
  }

  return {
    isValid: true,
    message: ''
  };
};